function pspServicioInit() {
  document.querySelectorAll('.psp-servicio-item').forEach(function (item) {
    if (item.dataset.pspServicioBound) return;
    item.dataset.pspServicioBound = 'true';

    var num = item.querySelector('.psp-servicio-num');
    var head = item.querySelector('.psp-servicio-head');
    if (!head) return;

    function toggle() {
      var open = item.classList.toggle('is-open');
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    head.addEventListener('click', toggle);
    if (num) num.addEventListener('click', toggle);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', pspServicioInit);
} else {
  pspServicioInit();
}
